import { useQuery, usePaginatedQuery } from 'react-query'
import { WidgetRepository } from 'repository/widget'

export const useLayerWidgets = (layerId: number, options?: any) => {
  const { status, data, error } = useQuery(
    ['widgets', { layerId }],
    () => WidgetRepository.fetchForLayer(layerId),
    options,
  )

  return {
    status,
    widgets: data,
    error,
  }
}

export const useLayersWidgets = (layerIds: number[], options?: any) => {
  const { status, data, error } = useQuery(
    ['widgets', { layerIds }],
    () => WidgetRepository.fetchForLayers(layerIds),
    options,
  )

  return {
    status,
    widgets: data,
    error,
  }
}

export const useFetchWidget = ({ widgetId, ...filters }: any, options?: any) => {
  const { status, resolvedData, latestData, error } = usePaginatedQuery(
    ['widget', { widgetId }, filters],
    () => WidgetRepository.fetch(widgetId, filters),
    options,
  )

  return {
    status,
    data: resolvedData ?? latestData,
    error,
  }
}
